import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Star, UserRound } from 'lucide-react';
import { shortTestimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  const hasSamples = shortTestimonials.some(testimonial => testimonial.isSample);
  return <section className="py-12 bg-sage-50 border-y border-sage-200" data-id="element-287" data-mp="3nzv73wfw6dig">
      <div className="max-w-7xl mx-auto px-4" data-id="element-288" data-mp="3nxijb2ngd8xh">
        <div className="text-center mb-7" data-id="element-289" data-mp="5kt04ypwm5js">
          <h2 className="text-forest font-bold tracking-widest uppercase text-sm" data-id="element-290" data-mp="5jrgw6yqicqz">
            What Hydroponic Growers Are Saying
          </h2>
          {hasSamples && <p className="text-xs text-charcoal/60 mt-2" data-id="element-291" data-mp="figyrzqmrx78">
              Placeholder comments shown for layout — to be replaced with verified customer feedback.
            </p>}
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-292" data-mp="2hby42wraglyt">
          {shortTestimonials.map((testimonial, index) => <motion.article key={testimonial.text} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-sage-200 p-6 rounded-2xl shadow-sm shadow-forest/5 flex flex-col" data-id="element-293" data-mp="2cdwju8i4mglr" data-mpi={index}>
              <div className="flex items-center justify-between gap-3 mb-4" data-id="element-294" data-mp="q5ynzidrp4r2">
                <div className="flex gap-1 text-gold" aria-label="5 out of 5 stars" data-id="element-295" data-mp="v2xfdt61qxlk">
                  {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={16} fill="currentColor" data-id="element-296" data-mp="144535haxsg1e" data-mpi={starIndex} />)}
                </div>
                {testimonial.isSample && <span className="text-xs font-bold uppercase tracking-wider text-forest bg-lime-soft px-2 py-0.5 rounded-full whitespace-nowrap" data-id="element-297" data-mp="1926sul2vbdlu">
                    Placeholder
                  </span>}
              </div>
              <p className="text-charcoal italic mb-6 text-sm leading-relaxed" data-id="element-298" data-mp="hzcpt7feq7ft">
                “{testimonial.text}”
              </p>
              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-sage-200" data-id="element-299" data-mp="d231xw7o23u3">
                <div className="w-10 h-10 rounded-full bg-sage-100 flex items-center justify-center text-forest shrink-0" aria-hidden="true" data-id="element-300" data-mp="r1c8s59zflle">
                  <UserRound size={18} data-id="element-301" data-mp="10xp2v49fw1go" />
                </div>
                <div className="min-w-0" data-id="element-302" data-mp="vzvuq5oksxdr">
                  <div className="font-bold text-forest text-sm" data-id="element-303" data-mp="vyukg3fdwex3">{testimonial.role}</div>
                  <div className="flex items-center gap-1 text-xs text-charcoal/60" data-id="element-304" data-mp="19pzcajcig2wv">
                    <MapPin size={11} className="text-leaf shrink-0" data-id="element-305" data-mp="15p70bic97jww" />
                    {testimonial.location}
                  </div>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}